import { ValueFormatterFunc } from 'ag-grid-community';
import capitalize from 'lodash/capitalize';

export const BOOLEAN_SET_FILTER_VALUES = ['true', 'false'];
export const booleanOptionFormatter: ValueFormatterFunc = (params) =>
  params?.value?.toUpperCase();

export const BOOLEAN_SET_FILTER_PARAMS = {
  values: BOOLEAN_SET_FILTER_VALUES,
  valueFormatter: booleanOptionFormatter,
};

export const capitalizeValueFormatter: ValueFormatterFunc = (params) =>
  params && params.value && capitalize(params.value);
